import { Component, forwardRef } from "@angular/core";
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from "@angular/forms";
import { GoogleMapService } from "../google-map/google-map.service";

@Component({
    selector: "pcg-ng-postcode-filter",
    templateUrl: "postcode-filter.component.html",
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => PostcodeFilterComponent),
            multi: true
        }
    ]
})
export class PostcodeFilterComponent implements ControlValueAccessor  {
    public constructor(
        public googleMapService: GoogleMapService
    ) { }

    protected currentValue: { postcode: string, distance: string };

    private onChange: (value: any) => void;
    private onTouched: () => void;

    public apply(): void {
        this.onChange(this.currentValue);
    }

    public registerOnChange(fn: any): void {
        this.onChange = fn;
    }

    public registerOnTouched(fn: any): void {
        this.onTouched = fn;
    }

    public writeValue(obj: any): void {
        this.currentValue = obj ?? {postcode: "", distance: ""};
    }
}
